export const locale = {
  'ROWOPERATION' : {
    'ADD' : 'Добавить',
    'EDIT' : 'Изменить',
    'REMOVE' : 'Удалить',
    'COPY' : 'Копировать',
  }
};
